import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { UncheckFugitive } from "src/entity/fugitive/fugitive.constants";
import { SettingUncheckFugitive } from "src/entity/settings/fugitive";
import { generateErrorMessage } from "src/utils/error-message";
import { onKeyDownNumberOnlyAndCopyPaste } from "src/utils/key-down-validate";

const { Text } = Typography;

const FugitiveUncheckModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingUncheckFugitive) => void;
}) => {
  const { form, loading, open, mode, isDuplicate, onDuplicateChange, onCloseModal, onSave } = props;
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const handleUncheckChange = (value: string) => {
    form.setFieldsValue({
      uncheck: value,
    });
  };

  const onChangeForm = (changeValue: any) => {
    if (["code", "uncheck"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Code or Uncheck already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["code", "uncheck"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="Uncheck" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        {errorDuplicate && (
          <>
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorDuplicate}</Text>
            </Row>
          </>
        )}
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Code"} required />}
                name="code"
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("Code"),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={100}
                  step={1}
                  precision={0}
                  onKeyDown={(e) => {
                    onKeyDownNumberOnlyAndCopyPaste(e);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Uncheck"} required />}
                name="uncheck"
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("Uncheck"),
                  },
                ]}
              >
                <Select options={UncheckFugitive} onChange={handleUncheckChange} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} lg={12}>
              <Form.Item label={<FormLabel label={"Reasons for Exception"} />} name="reasonForException">
                <Input />
              </Form.Item>
            </Col>

            {/* <Col xs={24}>
              <Form.Item label={<FormLabel label={"Remark"} />} name="remark">
                <Input.TextArea rows={3}></Input.TextArea>
              </Form.Item>
            </Col> */}
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default FugitiveUncheckModal;
